import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";

import CheckBoxRefinementList from "../../Components/CheckBoxRefinementList";
import MembershipFilter from "../../Components/DirectoryPanel/MembershipFilter";
import LocationFilter from "../../Components/DirectoryPanel/LocationFilter";
import {useTranslation} from "react-i18next";
import PartnerContactPanel from "../PartnerContact";

export default function FilterPanel(props) {
    const {t, i18n} = useTranslation();
    const projectSupportUrl = window.win_project_support_redirect;
    const tabs = [
        {
            id: 1,
            label: t('Directory.Membership.Type'),
            description: "Content of Tab 1",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <MembershipFilter/>
                    </div>
                    <div className="form__group">
                        <PartnerContactPanel/>
                    </div>
                </div>
            ),
        },
        {
            id: 2,
            label: t('Directory.Industry'),
            description: "Content of Tab 1",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="or"
                            attribute="directory_industry"
                            initialFacets={window.all_industries}
                        />
                    </div>
                </div>
            ),
        },
        {
            id: 7,
            label: t('Directory.ServicesOffered'),
            description: "Content of Tab 3",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="and"
                            attribute="service_offered_names"
                            initialFacets={window.all_services_offered}
                        />
                    </div>
                </div>
            ),
        },
        {
            id: 3,
            label: t('Filter.By'),
            description: "Content of Tab 1",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <LocationFilter/>
                    </div>
                </div>
            ),
        },
        {
            id: 4,
            label: t('Directory.BuildingType'),
            description: "Content of Tab 2",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="or"
                            attribute="building_type_names"
                            initialFacets={window.all_building_types}
                        />
                    </div>
                </div>
            ),
        },
        {
            id: 5,
            label: t('Directory.MaterialType'),
            description: "Content of Tab 3",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="and"
                            attribute="material_type_names"
                            initialFacets={window.all_material_types}
                        />
                    </div>
                </div>
            ),
        },
        {
            id: 6,
            label: t('Directory.ConstructionType'),
            description: "Content of Tab 3",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="and"
                            attribute="construction_type_names"
                            initialFacets={window.all_construction_types}
                        />
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="filters accordion">
            <Accordion preExpanded={[1, 2, 3, 4, 5, 6, 7]} allowMultipleExpanded>
                {tabs.map((tab) => (
                    <AccordionItem key={tab.id} uuid={tab.id}>
                        <AccordionItemHeading>
                            <AccordionItemButton>{tab.label}</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filterItem">{tab.filterItem}</div>
                        </AccordionItemPanel>
                    </AccordionItem>
                ))}
            </Accordion>
            <div className="form__group accordion__section">
                <div className="form__entry">
                    <p>
                        {t('Directory.Help1')}<br/>{t('Directory.Help2')}<a
                        href={projectSupportUrl}>{t('Directory.Help3')} &gt;</a>
                    </p>
                </div>
            </div>
        </div>
    );
}
